import clsx from 'clsx';
import { FC, HTMLAttributes, memo } from 'react';

interface SideMenuProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const SideMenu: FC<SideMenuProps> = memo(({ className, children }) => {
  return <div className={clsx('flex flex-col gap-sm', className)}>{children}</div>;
});
SideMenu.displayName = 'SideMenu';

interface SideMenuItemProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  selected?: boolean;
  showCount?: boolean;
  count?: number;
  countAnimation?: boolean;
}
const SideMenuItem: FC<SideMenuItemProps> = memo(
  ({ className, selected, showCount, count, countAnimation, children, ...props }) => {
    return (
      <div
        className={clsx(
          'p cursor-pointer rounded flex justify-between items-center gap',
          selected ? 'bg-active shadow-selected font-medium' : 'hover:bg-hover',
          className,
        )}
        {...props}
      >
        <div className="flex items-center gap flex-1 overflow-hidden">{children}</div>
        {showCount ? (
          <div
            key={count}
            className={clsx(
              'font-medium text-black/70',
              countAnimation && 'animate-number-change',
              selected && '!text-red-500',
            )}
          >
            {count ?? 0}
          </div>
        ) : null}
      </div>
    );
  },
);
SideMenuItem.displayName = 'MenuItem';

export { SideMenu, SideMenuItem };
